import * as angular from 'angular';
import RouterModule from './router/router.module';
import HttpModule from './http/http.module';
import CacheModule from './cache/cache.module';
import AuthModule from './auth/auth.module';
import DeviceModule from './device/device.module';
import LocalStorageModule from './local-storage/local-storage.module';

export default angular
  .module('FHL.core', [
    RouterModule,
    HttpModule,
    CacheModule,
    AuthModule,
    DeviceModule,
    LocalStorageModule,
  ])
  .name;



// WEBPACK FOOTER //
// ./src/app/core/core.module.js